import { loadMixPanel, loadGTM, loadTypekit, loadFontAwesome } from './vendor'

export const loadWithConsent = {
  loadNecessary() {
    loadFontAwesome()
    loadTypekit()
  },

  loadAnalytics() {
    const consent = this.getConsent()
    if (consent.analytics) {
      loadMixPanel()
      loadGTM(process.env.VUE_APP_GTM_ID)
    }
  },

  loadAll() {
    this.loadNecessary()
    this.loadAnalytics()
  },

  getConsent() {
    try {
      const stored = localStorage.getItem('cookies')
      if (stored) {
        const data = JSON.parse(stored)
        return (
          data.preferences || {
            necessary: true,
            analytics: false,
            advertising: false,
            functional: false
          }
        )
      }
    } catch (error) {
      throw error
    }

    return {
      necessary: true,
      analytics: false,
      advertising: false,
      functional: false
    }
  }
}
